import { useFetch as e } from "../../../utils/http-client.mjs";
import { RequestMethodsEnum as t } from "@systemeio/util";
//#region src/modules/file-selector/hooks/use-file-actions.ts
var n = () => {
	let { fetcher: n } = e({ method: t.delete }), { fetcher: r } = e({ method: t.get }), { fetcher: i } = e({ method: t.post });
	return {
		deleteFile: async ({ id: e }) => {
			await n("/api/dashboard/customer/data-files/" + e);
		},
		downloadFile: async ({ id: e }) => {
			let { link: t } = await r(`/api/dashboard/customer/data-files/${e}/download-link`), n = document.createElement("a");
			n.setAttribute("href", t), n.setAttribute("download", ""), n.click();
		},
		renameFile: async ({ id: e, name: t }) => await i(`/api/dashboard/customer/data-files/${e}/rename`, { name: t })
	};
};
//#endregion
export { n as useFileActions };
